import { PeopleBudgetDto } from './people-budget.dto';
import { PeopleJobTitleDto } from './people-job-title.dto';
import { PeopleMerchantGroupDto } from './people-merchant-group.dto';
import { PeopleRosterDto } from './people-roster.dto';
import { PeopleEmployeeWorkProfileDto } from './employee/people-employee-work-profile.dto';
import { PeopleQueryBaseDto } from './people-query-base.dto';

export class PeopleDepartmentDto {
  id?: number;
  name?: string;
  merchantGroupId?: number;
  isActive?: boolean;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;

  jobTitles?: PeopleJobTitleDto[];
  merchantGroup?: PeopleMerchantGroupDto;
  rosBudgets?: PeopleBudgetDto[];
  employeesWorkProfiles?: PeopleEmployeeWorkProfileDto[];
  rosters?: PeopleRosterDto[];
}

export interface PeopleDepartmentQueryDto extends PeopleQueryBaseDto {
  name?: string;
  isActive?: boolean;
  merchantGroupId?: number;
  join?: string | string[];
}

export interface PeopleDepartmentReadQueryDto {
  join?: string | string[];
}

export class PeopleDepartmentCostCentre {
  id: number;
  costCentreId: number;
  departmentId: number;
}
